export default __webpack_public_path__ + "static/genji-3f83e92abf0076006d4be710546d804b.png";